<template>
    <div class="col-12 col-lg-6" v-if="offlineQuestionnaires.length > 0">
        <div class="app-card app-card-basic d-flex flex-column align-items-start shadow-sm">
            <div class="app-card-header p-3 border-bottom-0">
                <div class="row align-items-center gx-3">
                    <div class="col-auto">
                        <div class="app-icon-holder">
                            <svg height="24px" viewBox="0 0 24 24" width="24px" fill="none"  stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <rect stroke="none" fill="none" height="24" width="24"/>
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </g>
                            </svg>
                        </div>

                    </div>
                    <div class="col-auto">
                        <h4 class="app-card-title">CONTROLE</h4>
                    </div>
                </div>
            </div>
            <div class="app-card-body px-4">

                <div class="intro"></div>
            </div>
            <div class="app-card-footer p-4 mt-auto">
                <button type="submit" class="btn app-btn-danger" @click="syncDebug()">
				    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
					    <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
					</svg>
					{{ syncButtonText }}
				</button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
	data() {
		return {
			offlineQuestionnaires: this.getFormsFromStorage(),
			syncing: false,
            ready: false
		}
	},

	computed: {
		syncButtonText() {
			if (this.syncing && !this.ready) {
				return 'Syncing...';
			} else if(this.ready) {
                return 'Klaar!';
            }else{
				return 'Verstuur';
			}
		}
	},

	created() {
		if (localStorage[storageKey] === undefined) {
			localStorage[storageKey] = JSON.stringify([]);
		}
	},

	methods: {
        getFormsFromStorage: function(){
            return JSON.parse(localStorage[storageKey])
        },
		syncDebug: async function () {
            this.syncing = true;
			// retrieve data waiting to be sent

			let data = this.getFormsFromStorage()

            let formData = new FormData();
            formData.append('debugdata',JSON.stringify(data));

            await axios.post('/submitdebug', formData).then(response => {
                        Toast.fire({icon: 'success', title: 'Gelukt'})
                        this.ready=true;
                        this.syncing = false;
                    }).catch(error => {
                        Toast.fire({icon: 'error', title: error})
            });
		},
	}
}
</script>
